import { Checkbox, FormControlLabel, Grid, InputLabel } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { SecondaryButton, TextBox } from '../../../../../Core/FormInput';
import { addTcardNotes, getTcardNotes } from '../../../../../Core/Service/TcardNotes-service';
import formatters from '../../../../../Core/Grid/inputFormatter';

const NoteReminderModal = (props) => {
    const [state, setState] = useState({ visibleToCustomer: false, tCardNoteText: '', tCardNoteReminder: '', editMode: false, selectedID: null });
    const [btnLoader, setBtnLoader] = useState(false);

    const getTcardNotesAndSaveToState = () => {
        setState((prev) => ({
            ...prev,
            loading: true,
            noteId: props.selectedNote.noteID,
            tCardID: props.selectedNote.tCardID,
            tCardNoteText: props.selectedNote.noteText,
            tCardNoteReminder: formatters.DateFormatter ? formatters.DateFormatter(props.selectedNote.noteReminder) : '',
            visibleToCustomer: props.selectedNote.cust,
            visibleToCustomer: props.selectedNote.visibleToCustomer
        }));
    };

    useEffect(() => {
        if (props.selectedNote) {
            getTcardNotesAndSaveToState();
        }
    }, [props.selectedNote]);

    const addNotesToServer = (tCardNoteClosed) => {
        setBtnLoader(true);

        addTcardNotes(state.tCardID, state.noteId, state.tCardNoteText, state.visibleToCustomer, state.tCardNoteReminder, tCardNoteClosed)
            .then((res) => {
                if (res.success) {
                    setState((prev) => ({
                        ...prev,
                        tCardNoteText: '',
                        selectedID: null,
                        editMode: false
                    }));
                    props.onClose(true); // Trigger refresh after add/edit
                }
            })
            .finally(() => {
                setBtnLoader(false);
            });
    };

    const fieldChange = (e) => {
        let { name, value } = e.target;
        setState((st) => ({ ...st, [name]: value }));
    };

    const handleCheckbox = (event) => {
        const { name, checked } = event.target;
        setState((st) => {
            const nst = { ...st };
            nst[name] = checked;
            return nst;
        });
    };

    return (
        <Grid container spacing={2} alignItems="center" justifyContent="center">
            <Grid item xs={12}>
                <InputLabel>{'New Note'}</InputLabel>
                <TextBox
                    // label={state.editMode ? 'Edit Note' : 'New Note'}
                    fullWidth
                    name="tCardNoteText"
                    onChange={fieldChange}
                    value={state.tCardNoteText}
                    autoFocus={true}
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <InputLabel>Reminder Date</InputLabel>
                <TextBox
                    id="date"
                    type="date"
                    name="tCardNoteReminder"
                    fullWidth
                    value={state.tCardNoteReminder}
                    onChange={fieldChange}
                    InputLabelProps={{
                        shrink: true
                    }}
                    InputProps={{ inputProps: { max: `${state.endDate}` } }}
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <FormControlLabel
                    control={<Checkbox checked={state.visibleToCustomer} onChange={handleCheckbox} name="visibleToCustomer" />}
                    label="Visible To Customer?"
                />
            </Grid>
            <Grid item xs={12}>
                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        <SecondaryButton fullWidth onClick={() => addNotesToServer(false)}>
                            Update
                        </SecondaryButton>
                    </Grid>
                    <Grid item xs={6}>
                        <SecondaryButton fullWidth onClick={() => addNotesToServer(true)}>
                            Close Note
                        </SecondaryButton>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
};

export default NoteReminderModal;
